import { render, staticRenderFns } from "./CustomerSupplierCreateUpdate.vue?vue&type=template&id=a2eb7a02&scoped=true&"
import script from "./CustomerSupplierCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerSupplierCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSupplierCreateUpdate.vue?vue&type=style&index=0&id=a2eb7a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb7a02",
  null
  
)

export default component.exports